import styled from "styled-components";

export const Text = styled.p`
    color: black;
    text-align: center;
    
`